function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M364.8,203.9L354.7,128H392c13.2,0,24-10.8,24-24V24c0-13.2-10.8-24-24-24H120c-13.2,0-24,10.8-24,24v80 c0,13.2,10.8,24,24,24h37.3l-10.1,75.9C98.9,231.5,64,278.4,64,335.2c0,8.8,7.2,16,16,16h160V472c0,0.7,0.1,1.3,0.2,1.9l8,32 c2,8,13.5,8.1,15.5,0l8-32c0.2-0.6,0.2-1.3,0.2-1.9V351.2h160c8.8,0,16-7.2,16-16C448,278.4,413.1,231.5,364.8,203.9L364.8,203.9z  M97.3,319.2c6.8-42.9,39.6-76.4,79.5-94.5L192,96h-64V32h256v64h-64l15.3,128.8c40,18.2,72.7,51.8,79.5,94.5L97.3,319.2L97.3,319.2 z"
});

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.d822ca88.svg";
export { ForwardRef as ReactComponent };